"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformAssignationsToVehicleTypeAssignationsPairs = void 0;
const utils_1 = require("@daytrip/utils");
const Assignation_1 = require("../models/Assignation");
const SimpleOrderWithAssignationsAssignation_1 = require("../models/SimpleOrderWithAssignationsAssignation");
function transformAssignationsToVehicleTypeAssignationsPairs(vehicleTypes, assignations) {
    const result = [];
    vehicleTypes.forEach((vehicleType) => {
        const currentAssignation = assignations.find((assignation) => assignation.vehicleType === vehicleType && !assignation.cancelledAt && !assignation.declinedAt);
        if (!(0, utils_1.isUndefinedOrNull)(currentAssignation)) {
            if (currentAssignation instanceof SimpleOrderWithAssignationsAssignation_1.SimpleOrderWithAssignationsAssignation) {
                assignations = assignations.filter((assignation) => assignation instanceof SimpleOrderWithAssignationsAssignation_1.SimpleOrderWithAssignationsAssignation &&
                    assignation.assignationId !== currentAssignation.assignationId);
            }
            else if (currentAssignation instanceof Assignation_1.Assignation) {
                assignations = assignations.filter((assignation) => assignation instanceof Assignation_1.Assignation && assignation._id !== currentAssignation._id);
            }
        }
        result.push({
            vehicleType,
            assignation: currentAssignation,
        });
    });
    return result;
}
exports.transformAssignationsToVehicleTypeAssignationsPairs = transformAssignationsToVehicleTypeAssignationsPairs;
//# sourceMappingURL=transformAssignationsToVehicleTypeAssignationsPairs.js.map